import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoDieta: [],
  },

  getters: {
    getTipoDieta: (state) => state.tipoDieta,
  },

  mutations: {
    SET_TIPO_DIETA(state, tipoDieta) {
      state.tipoDieta = tipoDieta;
    },
  },

  actions: {
    async fetchTipoDieta({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/tipoDieta`)
        .then((response) => {
          commit('SET_TIPO_DIETA', response.data.data);
        });
    },

    async saveTipoDieta(context, tipoDieta) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/tipoDieta`, tipoDieta);
    },

    async updateTipoDieta(_, tipoDieta) {
      await axios
        .put(`PoliciaCuadrantes/C3/historiaClinica/${tipoDieta.fk_idPersonal}/tipoDieta/${tipoDieta.fk_idTipoDieta}`, tipoDieta);
    },
  },
};
